import { faCircleNotch, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorMessage from "components/reusable/ErrorMessage";
import AuthContext from "context/AuthContext";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { validationRules } from "utils/constants";
import { generateRandomID } from "utils/reusableMethods";

const Login = ({ activeKey }) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  let { loginUser } = useContext(AuthContext);
  const [icon2, setIcon2] = useState(true);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(JSON.parse(localStorage.getItem("rememberMe")) ? JSON.parse(localStorage.getItem("rememberMe")) : false);
  let latestWindow;

  const handleLogin = async (data) => {
    let sendData = {
      device_id: generateRandomID(10),
      device_type: "web",
      device_token: generateRandomID(20),
    };
    try {
      setLoading(true);
      if (data?.username !== "") {
        sendData.username = data?.username;
      }

      sendData.password = data.password;
      if (rememberMe) {
        localStorage.setItem("username", data?.username);
        localStorage.setItem("password", data?.password);
      }
      await loginUser(sendData);
    } catch (err) {}
    setLoading(false);
  };

  const handleSmartfinLogin = async () => {
    window.location.href = `https://web.smartfin.al/AccountAl/LoginAlpay?redirectUrl=${window.location.protocol}//${window.location.host}/login-with-smartfin-callback`;
  };

  useEffect(() => {
    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey]);

  useEffect(() => {
    if (rememberMe) {
      reset({
        username: localStorage.getItem("username"),
        password: localStorage.getItem("password"),
      });
    } else {
      localStorage.removeItem("username");
      localStorage.removeItem("password");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheckboxChange = (e) => {
    setRememberMe(e.target.checked);
    localStorage.setItem("rememberMe", e.target.checked);
  };
  const navigate = useNavigate();

  function goRegister() {
    navigate("/register");
  }

  const preventSpace = (e) => {
    if (e?.which === 32) {
      e.preventDefault();
    }
  };

  const preventSpacePass = (e) => {
    e.target.value = e.target.value.trimStart();
    e.target.value = e.target.value.replace(/  +/g, " ");
  };
  useEffect(() => {
    if (latestWindow) {
      latestWindow.onload = function () {
        // var latestURL = latestWindow.location.href;
      };
    }
  }, [latestWindow]);
  return (
    <>
      <div className="block md:hidden"></div>
      <div className="flex justify-center grid grid-cols-2 items-center w-full h-screen no-scrollbar overflow-hidden">
        <div className="hidden md:flex col-span-1 h-full bg-primary justify-center items-center">
          <div>
            <img className="h-[5rem] cursor-pointer" src="images/whitelogo.svg" alt="LOGO" />
          </div>
        </div>
        <div className="col-span-2 md:col-span-1 flex flex-col items-center justify-center">
          <div style={{ height: "5rem" }} className="block w-full flex justify-center items-center p-4 mb-5">
            <span className="h4 m-0 text-center font-medium text-xl">{t("O_LOGIN")}</span>
          </div>{" "}
          <form className="max-w-sm w-[90%] md:w-[20rem]" onSubmit={handleSubmit(handleLogin)}>
            <div className="mb-5">
              <input
                type="text"
                id="username"
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("USERNAME")}
                onKeyDown={(e) => preventSpace(e)}
                {...register("username", {
                  required: t("REGISTER_USERNAME"),
                })}
                required
              />
            </div>
            <div className="mb-5 relative">
              <input
                type={icon2 ? "password" : "text"}
                id="password"
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder="••••••••"
                onInput={preventSpacePass}
                autoComplete="new-password"
                {...register("password", {
                  required: t("REGISTER_PASSWORD"),
                  pattern: {
                    value: validationRules.password,
                    message: validationRules.passwordMessage,
                  },
                })}
                required
              />
              {icon2 ? (
                <span className="password_view cursor-pointer absolute top-[0.8rem] right-[1rem]" onClick={() => setIcon2(!icon2)}>
                  <FontAwesomeIcon icon={faEye} />
                </span>
              ) : (
                <span className="password_view cursor-pointer absolute top-[0.8rem] right-[1rem]" onClick={() => setIcon2(!icon2)}>
                  <FontAwesomeIcon icon={faEyeSlash} />
                </span>
              )}
              <ErrorMessage message={errors?.password?.message} />
            </div>

            <div className="flex justify-between items-center">
              <div className="flex gap-1">
                <input type="checkbox" checked={rememberMe} onChange={(e) => handleCheckboxChange(e)} />
                <span>{t("O_REMEMBER_ME")}</span>
              </div>

              <div className="text-sm-end text-primary font-medium">
                <Link to="/forgot-password" className="link">
                  {t("FORGOT_PASSWORD")}?
                </Link>
              </div>
            </div>

            <div className="w-full mt-5">
              {loading ? (
                <div className="btn btn_theme w-full flex items-center justify-center p-3">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                </div>
              ) : (
                <button className="btn btn_theme w-full text-white" type="submit">
                  {t("O_LOGIN_TAB")}
                </button>
              )}
            </div>
            {/* <div sm={10} className='text-center w-100 mb-2 mt-4'>
                  {t('LOGIN_DO_NOT')}
                  <Link to='/register' className='link'>
                    {' '}
                    {t('LOGIN_REGISTER_HERE')}
                  </Link>
                </div> */}
            <div sm={8} className="text-center w-100 mb-2 mt-4">
              <span className="font-medium me-2">{t("NO_ACCOUNT?")}</span>
              <span onClick={() => goRegister()} className="link font-medium text-primary" style={{ cursor: "pointer" }}>
                {" "}
                {t("REGISTER_REGISTER")}
              </span>
            </div>

            <div class="flex items-center">
              <div class="flex-grow border-t border-gray-300"></div>
              <span class="flex-shrink mx-4 text-gray-400">{t("or")}</span>
              <div class="flex-grow border-t border-gray-300"></div>
            </div>

            <div className="w-full mt-5">
              <button className="btn btn_theme w-full text-white flex justify-between items-center h-10 gap-1 bg-[#08412c] overflow-hidden relative" type="button" onClick={handleSmartfinLogin}>
                <span className="flex items-center justify-center h-full shrink-0">
                  <img src="images/smartfin.png" className="h-20 w-auto max-w-none object-cover brightness-0 invert" alt="Smartfin" style={{ minWidth: "40px" }} />
                </span>

                <span className="relative z-10 pe-5">{t("O_LOGIN_SMARTFIN")}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
